// extracted by mini-css-extract-plugin
module.exports = {"media":"eelJD","mediaVideo":"wqCm4"};